// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "categories-landing-" + (chunkId === 226 ? "webfooter-Footer" : chunkId) + "-st-" + {"139":"2dd0757b","213":"4d9f66fe","226":"bdbbbf0c","249":"a31efad6","313":"ce04f557","790":"690cfa3c","846":"883853ca"}[chunkId] + ".js";
};